import * as React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
    // Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Card,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import styled from 'styled-components'
import { devices } from 'utils/screen_sizes'
import { useTranslation, Trans } from 'react-i18next'
import Accordion from './Accordion/Accordion'

const StyledCard = styled(Card)`
    padding: 2rem 1rem;
    .MuiPaper-elevation1 {
        box-shadow: none;
    }
    .MuiAccordionSummary-root {
        @media ${devices.mobileM} {
            padding: 0px;
        }
        @media ${devices.laptop} {
            padding: 0px 16px;
        }
    }
`

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(16),
        fontWeight: theme.typography.fontWeightBold,
        fontFamily: 'lato',
    },
    description: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightNormal,
        fontFamily: 'lato',
    },
}))

const FaqSection = () => {
    const { t, i18n } = useTranslation()

    const faqs = [
        {
            title: `${t('description.faq_q1')}`,
            // title: 'What criteria did you use to evaluate my phone?',
            description: `${t('description.faq_a1')}`,
        },
        {
            title: `${t('description.faq_q2')}`,
            description: `${t('description.faq_a2')}`,
        },
        {
            title: `${t('description.faq_q3')}`,
            description: `${t('description.faq_a3')}`,
        },
        {
            title: `${t('description.faq_q4')}`,
            description: `${t('description.faq_a4')}`,
        },
        {
            title: `${t('description.faq_q5')}`,
            description: `${t('description.faq_a5')}`,
        },
        {
            title: `${t('description.faq_q6')}`,
            description: `${t('description.faq_a6')}`,
        },
        {
            title: `${t('description.faq_q7')}`,
            description: `${t('description.faq_a7')}`,
        },
    ]

    const classes = useStyles()
    return (
        <>
            <ul className="accordion">
                {faqs?.map(({ title, description },i) => (
                    <Accordion key={i} heading={title} content={description} />
                ))}
            </ul>
            {/* <div className={classes.root}>
                {faqs.map(({ title, description }, i) => (
                    <Accordion key={title + i}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls={`panel${i}a-content`}
                            id={`panel${i}a-header`}
                        >
                            <Typography className={classes.heading}>
                                {title}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography className={classes.description}>
                                {description}
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                ))}
            </div> */}
        </>
    )
}

export default FaqSection
